import React from 'react';
import styles from '../styles.module.scss';
import cN from 'classnames';
import { I_FilterItemList, I_FilterOption } from '../interface';

import CheckboxItem from './CheckboxItem';

interface I_GiftBlockProps {
    title: string;
    cols: number;
    giftOptions: I_FilterOption[] | undefined;
    mobileProps?: {
        tempMFilter: I_FilterItemList | null;
        setTempMFilter: Function;
    };
}

// 禮品
const GiftBlock = (props: I_GiftBlockProps) => {
    const moduleName = 'filterBlock';
    const { title, cols, giftOptions, mobileProps } = props;

    return (
        <li className={styles[moduleName]}>
            <div className={cN(styles.Block_title)}>
                <div className={cN(styles.Title)}>{title}</div>
            </div>
            <div className={cN(styles.Block_content, { show: true })}>
                <ul className={cN(styles.CheckBoxes)}>
                    {giftOptions?.map((option) => {
                        return (
                            <CheckboxItem
                                key={`${option.text}-${option.value}`}
                                filterType="Gifts"
                                cols={`col${cols}`}
                                text={option.text}
                                value={option.value}
                                isDisable={option.disable}
                                {...mobileProps}
                            />
                        );
                    })}
                </ul>
            </div>
        </li>
    );
};

export default GiftBlock;
